import type { ReactElement } from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { Button } from '@csa/ui';

/**
 * The post-logout landing page registered with Entra.
 *
 * Reached only after Entra has ended its own session, which is why it says so
 * explicitly: on a shared support workstation the difference between "signed
 * out of the tool" and "signed out of Microsoft" is the difference between the
 * next person inheriting your identity and not.
 */
export function SignedOutScreen(): ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center bg-sunken p-6">
      <div className="w-full max-w-md rounded-lg border border-line bg-surface p-8 text-center shadow-card">
        <span className="mx-auto flex size-11 items-center justify-center rounded-full bg-brand-subtle">
          <CheckCircleIcon className="size-6 text-brand" aria-hidden="true" />
        </span>
        <h1 className="mt-5 text-lg font-semibold tracking-tight text-body">You are signed out</h1>
        <p className="mt-2 text-sm leading-relaxed text-muted">
          Your session has ended and your Microsoft sign-in was cleared from this browser.
        </p>
        <Button
          variant="primary"
          size="md"
          className="mt-6 w-full"
          onClick={() => {
            // Full navigation rather than history manipulation, so the
            // application bootstraps cleanly against a now-empty MSAL cache.
            window.location.assign('/');
          }}
        >
          Sign in again
        </Button>
      </div>
    </div>
  );
}
